import { useMutation, useQuery } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_CORRECT_SCORE, GQL_REVOKE_SCORE_CORRECTION, GQL_SCORE_CORRECTIONS } from '~/gql/scorm/score-corrections'

/**
 * Corrections de score d'un suivi (#161) : l'historique, corriger, annuler.
 * Après chaque changement, l'historique et la table sont relus.
 */
export function useScoreCorrection(trackingId: string | null, onChanged: () => unknown) {
  const { t } = useTranslation()
  const { data, loading, error, refetch } = useQuery(GQL_SCORE_CORRECTIONS, { variables: { trackingId: trackingId ?? '' }, skip: !trackingId })
  const [correctScore, { loading: saving }] = useMutation(GQL_CORRECT_SCORE)
  const [revokeCorrection, { loading: revoking }] = useMutation(GQL_REVOKE_SCORE_CORRECTION)

  const run = async (action: () => Promise<unknown>, successKey: string): Promise<boolean> => {
    try {
      await action()
      await Promise.all([refetch(), onChanged()])
      toast.success(t(successKey))
      return true
    } catch {
      toast.error(t('scoreCorrection.error'))
      return false
    }
  }

  return {
    history: data?.scoreCorrections ?? [],
    loading,
    error,
    busy: saving || revoking,
    correct: (percent: number, reason: string) => run(
      () => correctScore({ variables: { input: { trackingId: trackingId ?? '', percent, reason } } }),
      'scoreCorrection.saved',
    ),
    revoke: () => run(() => revokeCorrection({ variables: { trackingId: trackingId ?? '' } }), 'scoreCorrection.revoked'),
  }
}
